<template>
  <v-container grid-list-lg fluid>
    <router-view></router-view>
  </v-container>
</template>
<script>
// import RegisterStoreModule from '@/mixins/RegisterStoreModule'
// import userStore from './store.js'

export default {
  name: 'Deliverys',
  // mixins: [RegisterStoreModule],
  // created() {
  //   this.registerStoreModule('user', userStore)
  // },
}
</script>
